if (!customElements.get('wls-partnership-bar')) {
  class WLSPartnerbar extends HTMLElement {
    constructor() {
      super();

      this.scrollSpeed = Number(this.getAttribute('data-speed') || 60); // px/sec
      this.mediaQuery = window.matchMedia('(max-width: 767px)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.boundUpdate = this._debounce(this.update.bind(this), 150);
      this.boundOnChange = this.update.bind(this);
    }

    get track() {
      return this.querySelector('.wls-partnerbar__track');
    }

    get group() {
      return this.querySelector('.wls-partnerbar__group');
    }

    connectedCallback() {
      if (!this.track) return;

      this._waitForImages(this).then(() => this.update());

      window.addEventListener('resize', this.boundUpdate);
      this.mediaQuery.addEventListener?.('change', this.boundOnChange);
      this.reducedMotion.addEventListener?.('change', this.boundOnChange);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.boundUpdate);
      this.mediaQuery.removeEventListener?.('change', this.boundOnChange);
      this.reducedMotion.removeEventListener?.('change', this.boundOnChange);
    }

    // Measure one logo group and expose the scroll distance + duration as CSS
    // custom properties. The motion itself is a compositor-driven CSS animation,
    // so this runs only on load / resize — never per frame.
    update() {
      const track = this.track;
      const group = this.group;
      if (!track || !group) return;

      if (!this.mediaQuery.matches || this.reducedMotion.matches) {
        track.classList.remove('is-animating');
        return;
      }

      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const shift = group.offsetWidth + gap;
      if (shift <= 0) return;

      const duration = shift / this.scrollSpeed;
      track.style.setProperty('--marquee-shift', `${shift}px`);
      track.style.setProperty('--marquee-duration', `${duration}s`);
      track.classList.add('is-animating');
    }

    _waitForImages(scope) {
      const images = Array.from(scope.querySelectorAll('img'));
      if (images.length === 0) return Promise.resolve();

      return Promise.all(
        images.map((img) =>
          img.complete
            ? Promise.resolve()
            : new Promise((resolve) => {
                img.addEventListener('load',  resolve, { once: true });
                img.addEventListener('error', resolve, { once: true });
              })
        )
      );
    }

    _debounce(fn, delayMs = 150) {
      let id;
      return (...args) => {
        clearTimeout(id);
        id = setTimeout(() => fn(...args), delayMs);
      };
    }
  }

  customElements.define('wls-partnership-bar', WLSPartnerbar);
}
